import { render, staticRenderFns } from "./BookingAdditionalCharges.vue?vue&type=template&id=0ee6255c&"
import script from "./BookingAdditionalCharges.vue?vue&type=script&lang=js&"
export * from "./BookingAdditionalCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports